<template>
  <div class="legacy-sort-host">
  <LegacyPortfolioOverlay :open="true" class="legacy-sort-overlay" @click.self="$emit('close')" @keydown="onKeydown">
    <section ref="dialog" class="legacy-sort-dialog" role="dialog" aria-modal="true" aria-label="Ordenar listado" tabindex="-1">
      <header>
        <h2>Ordenar listado</h2>
        <button type="button" class="legacy-sort-close" aria-label="Cerrar ordenación" @click="$emit('close')">
          <span class="material-icons-outlined" aria-hidden="true">close</span>
        </button>
      </header>
      <div class="legacy-sort-options">
        <div v-for="option in options" :key="option.field" class="legacy-sort-group" role="group" :aria-label="option.header">
          <h3>{{ option.header }}</h3>
          <div class="legacy-sort-directions">
            <button v-for="(direction, index) in ['asc', 'desc']" :key="direction" type="button"
              :aria-pressed="selected === option.name[index]" :data-sort-field="option.field" :data-sort-direction="direction"
              @click="choose(option, direction, index)">
              <span class="material-icons-outlined" aria-hidden="true">{{ direction === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</span>
              <span>{{ option.name[index] }}</span>
            </button>
          </div>
        </div>
        <p v-if="!options.length" class="legacy-sort-empty">No hay criterios de ordenación disponibles.</p>
      </div>
    </section>
  </LegacyPortfolioOverlay>
  </div>
</template>

<script>
import LegacyPortfolioOverlay from './LegacyPortfolioOverlay.vue';

export default {
  name: 'LegacySortDialog',
  components: { LegacyPortfolioOverlay },
  props: {
    options: { type: Array, default: () => [] },
    selected: { type: String, default: '' }
  },
  mounted() {
    this.$nextTick(() => {
      const dialog = this.$refs.dialog;
      if (dialog) (dialog.querySelector('[aria-pressed=true]') || dialog).focus();
    });
  },
  methods: {
    choose(option, type, index) {
      const name = option.name[index];
      this.$emit('select', { field: option.field, type, name, header: option.header });
      this.$emit('close');
    },
    onKeydown(event) {
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); this.$emit('close'); }
      if (event.key !== 'Tab') return;
      const dialog = this.$refs.dialog;
      const buttons = Array.from(dialog.querySelectorAll('button:not(:disabled)'));
      const first = buttons[0], last = buttons[buttons.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || document.activeElement === dialog)) { event.preventDefault(); first.focus(); }
    }
  }
};
</script>

<style lang="scss" scoped>
.legacy-sort-overlay { position: fixed; inset: 0; display: flex; align-items: center; justify-content: center; padding: 24px; background: rgba(0,0,0,.4); }
.legacy-sort-dialog { display: flex; flex-direction: column; width: 560px; max-width: 100%; max-height: 80vh; overflow: hidden; border: 1px solid var(--legacy-control-border); border-radius: 8px; background: var(--legacy-control-bg); color: var(--legacy-list-text); box-shadow: 0 12px 36px rgba(0,0,0,.2); outline: none; }
header { display: flex; align-items: center; justify-content: space-between; gap: 16px; padding: 16px 20px; background: var(--legacy-list-heading); color: var(--legacy-list-heading-text); border-bottom: 1px solid var(--legacy-border); }
h2 { margin: 0; font-size: 18px; font-weight: 600; }
button { font: inherit; cursor: pointer; }
button:focus-visible { outline: 2px solid #00aedd; outline-offset: -3px; }
.legacy-sort-close { display: flex; padding: 4px; border: 0; border-radius: 4px; color: inherit; background: transparent; }
.legacy-sort-close:hover { background: rgba(255,255,255,.15); }
.legacy-sort-options { min-height: 0; overflow-y: auto; padding: 4px 20px 16px; }
.legacy-sort-group { padding: 16px 0; }
.legacy-sort-group + .legacy-sort-group { border-top: 1px solid var(--legacy-border); }
h3 { margin: 0 0 8px; font-size: 12px; font-weight: 600; color: var(--legacy-control-muted); }
.legacy-sort-directions { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; }
.legacy-sort-directions button { display: flex; align-items: center; gap: 8px; min-height: 42px; padding: 10px; border: 1px solid var(--legacy-control-border); border-radius: 5px; background: transparent; color: inherit; text-align: left; font-size: 13px; }
.legacy-sort-directions .material-icons-outlined { font-size: 18px; flex-shrink: 0; }
.legacy-sort-directions button:hover { background: var(--legacy-list-hover); }
.legacy-sort-directions button[aria-pressed=true] { background: var(--legacy-active-bg); color: var(--legacy-active-text); border-color: var(--legacy-active-bg); }
.legacy-sort-empty { margin: 20px 0; color: var(--legacy-control-muted); }
</style>
